import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MDBBtn } from 'mdbreact';
import 'antd/dist/antd.css';

import { Select, Drawer, Tabs, Upload } from 'antd';
import { GetLicenciasFacturacionDesgloseEnAPI, GetListaHTMLEnAPI, GetListaPDFEnAPI, GetCSVEnAPI } from "../../action/actionCreatorsRequests";

import { MSGERROR, MSGOK, traducirPagina, descargarPdfPasandoBase64, descargarDocPasandoBase64Generico, convertirCodigoAMeses } from "../../librerias/funciones"
import FichaImpresionGenerico from '../../components/FichaImpresionGenerico'
import FichaHistoricoTaller from './FichaHistoricoTaller';
import {
    SearchOutlined,
    CloseOutlined,
    UserOutlined,
    ShopOutlined,
    PrinterOutlined,
    EyeOutlined
} from '@ant-design/icons';
const { Dragger } = Upload;
const { Option } = Select;
const { TabPane } = Tabs;

const FichaHistoricoSocio = ({ props, configApp, }) => {
    const [DOC_HTML, setDOC_HTML] = React.useState("");
    const [hayEmpresa, setHayEmpresa] = React.useState(false);
    const [licencias, setLicencias] = React.useState([]);
    const [licenciasAux, setLicenciasAux] = React.useState([]);


    const [abrirImpresion, setAbrirImpresion] = React.useState(false);
    const [textoBuscador, setTextoBuscador] = React.useState("");
    const [estadoCliente, setEstadoCliente] = React.useState(false);
    const [estadoMostrador, setEstadoMostrador] = React.useState(false);
    const [totales, setTotales] = React.useState({
        TOTAL_CLIENTES: 0,
        TOTAL_MOSTRADORES: 0,
        TOTAL_LICENCIAS: 0
    });



    const [abrirFichaEstadistica, setAbrirFichaEstadistica] = React.useState(false);

    const [registroSeleccionado, setRegistroSeleccionado] = React.useState({});




    const buscarRegistros = (MES, ANYO, ID_SOCIO, ID_DEPARTAMENTO) => {
        GetLicenciasFacturacionDesgloseEnAPI(MES, ANYO, ID_SOCIO, ID_DEPARTAMENTO).then((licencia) => {
            if (licencia !== undefined) {
                if (licencia.REGISTROS !== undefined && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {
                    setLicencias(licencia.REGISTROS)
                    setLicenciasAux(licencia.REGISTROS)
                    let totalLicencias = 0;
                    let totalLicenciasTalleres = 0;
                    let totalLicenciasMostradores = 0;

                    licencia.REGISTROS.map((registro) => {
                        totalLicencias += registro.LICENCIAS_SERTEC
                        if (registro.TIPO === "C") {
                            totalLicenciasTalleres += registro.LICENCIAS_SERTEC
                        }

                        if (registro.TIPO === "M") {
                            totalLicenciasMostradores += registro.LICENCIAS_SERTEC
                        }
                    })

                    setTotales({
                        TOTAL_CLIENTES: totalLicenciasTalleres,
                        TOTAL_MOSTRADORES: totalLicenciasMostradores,
                        TOTAL_LICENCIAS: totalLicencias
                    })
                } else {
                    setLicencias(null)
                    setLicenciasAux(null)

                }
            }
        })

    }


    const filtrarEnTabla = (palabra, registros) => {
        let resultado = []
        if (palabra !== "") {
            if (registros !== null) {
                let resultadoFiltro = registros.filter((item) => {
                    return item.TALLER.toUpperCase() === palabra.toUpperCase() ||
                        item.TALLER.toUpperCase().includes(palabra.toUpperCase()) ||
                        item.ID_TALLER.toString().toUpperCase().includes(palabra.toUpperCase()) ||
                        item.CONSULTAS_APP.toString().toUpperCase().includes(palabra.toUpperCase()) ||
                        item.CONSULTAS_TELEFONO.toString().toUpperCase().includes(palabra.toUpperCase()) ||
                        item.CONSULTAS_WEB.toString().toUpperCase().includes(palabra.toUpperCase()) ||
                        item.CONSULTAS_TOTAL.toString().toUpperCase().includes(palabra.toUpperCase())

                })

                if (resultadoFiltro.length > 0) {
                    //setProveedores(resultadoFiltro);
                    resultado = resultadoFiltro;
                } else {
                    //setProveedores(null);
                    //resultado = registros;
                    resultado = null;
                }
            }
        } else {
            resultado = licenciasAux;
            //setProveedores(proveedoresAUX);
        }

        return resultado;

    }


    const buscarDocumento = () => {
        const TITULO = `${traducirPagina("Facturacion").toUpperCase()} ${traducirPagina(convertirCodigoAMeses(props.MES.toString())).toUpperCase()} ${props.ANYO}`;
        const SUBTITULO = `${props.title} ${props.REGISTRO_SELECCIONADO.SOCIO}`;

        const REGISTROS = licencias.map(registro => {
            return { ID: registro.ID_TALLER, TALLER: registro.TALLER, PAIS: registro.PAIS, APP: registro.CONSULTAS_APP, TELEFONO: registro.CONSULTAS_TELEFONO, WEB: registro.CONSULTAS_WEB, TOTALES: registro.CONSULTAS_TOTAL };
        });
        GetListaHTMLEnAPI(REGISTROS, TITULO, SUBTITULO).then((doc) => {
            if (doc !== undefined) {
                if (doc !== null || doc !== "") {
                    setDOC_HTML(doc.HTML)
                } else {
                    setDOC_HTML(null)
                }
            }
        })
    }
    

    const buscarDocumentoPDF = () => {
        const TITULO = `${traducirPagina("Facturacion").toUpperCase()} ${traducirPagina(convertirCodigoAMeses(props.MES.toString())).toUpperCase()} ${props.ANYO}`;
        const SUBTITULO = `${props.title} ${props.REGISTRO_SELECCIONADO.SOCIO}`

        const REGISTROS = licencias.map(registro => {
            return { ID: registro.ID_TALLER, TALLER: registro.TALLER, PAIS: registro.PAIS, APP: registro.CONSULTAS_APP, TELEFONO: registro.CONSULTAS_TELEFONO, WEB: registro.CONSULTAS_WEB, TOTALES: registro.CONSULTAS_TOTAL };
        });
        GetListaPDFEnAPI(REGISTROS, TITULO, SUBTITULO).then((doc) => {
            if (doc !== undefined) {
                if (doc.PDF !== "" && doc.PDF !== null) {
                    descargarPdfPasandoBase64(doc.PDF)
                }
            }
        })
    }

    const buscarDocumentoCSV = () => {
        const REGISTROS = licencias.map(registro => {
            return { ID: registro.ID_TALLER, TALLER: registro.TALLER, PAIS: registro.PAIS, APP: registro.CONSULTAS_APP, TELEFONO: registro.CONSULTAS_TELEFONO, WEB: registro.CONSULTAS_WEB, TOTALES: registro.CONSULTAS_TOTAL };
        });
        GetCSVEnAPI(REGISTROS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")

                }
            }
        })
    }



    const filtrarDatosLocales = (licencias, esMostrador, textoBuscador) => {
        let filtroLicencias = [...licencias];

        if (esMostrador > 0) {
            filtroLicencias = filtroLicencias.filter((item) => (esMostrador === 2) ? item.TIPO === "C" : item.TIPO === "M")
        }
        if (textoBuscador !== "") {
            filtroLicencias = filtrarEnTabla(textoBuscador, filtroLicencias)
        }

        let verificarLicencia = filtroLicencias === undefined || filtroLicencias === null ? null : filtroLicencias.length === 0 ? null : filtroLicencias
        setLicencias(verificarLicencia)
    }

    if (!hayEmpresa && props.ABRIR_FICHA) {
        setHayEmpresa(true);


        buscarRegistros(props.MES, props.ANYO, props.REGISTRO_SELECCIONADO.ID_SOCIO, props.ID_DEPARTAMENTO);


    } else {
        if (!props.ABRIR_FICHA && hayEmpresa) {
            setHayEmpresa(false);

        }
    }

    return (
        <div>
            <Drawer
                width={"90%"}
                onClose={() => { props.CERRAR_FICHA(false) }}
                visible={props.ABRIR_FICHA}
                placement={"right"}
                closable={false}

                bodyStyle={{ padding: '0px' }}
                style={{ color: '#fff' }}>




                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => {
                            props.CERRAR_FICHA(false)
                        }}></CloseOutlined >
                        <div>
                            {`${props.title} ${props.REGISTRO_SELECCIONADO.SOCIO}`}
                        </div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>

                <div style={{ margin: '10px' }}>
                    <div className="flex-container mdb-skin" style={{ backgroundColor: '#dcdcdc', padding: '10px', marginBottom: '10px' }}>

                        <div style={{ flexGrow: '6', textAlign: 'left' }}>
                            <div className="grid-container" style={{ backgroundColor: '#eee' }}>
                                <div className="grid-item">
                                    <input id="buscadorClienteTaller" className="form-control" type="text" aria-label="Search" placeholder={traducirPagina("Buscar_en_tabla")} style={{ backgroundColor: "transparent", width: '310px', border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off" onChange={(e) => {
                                        filtrarDatosLocales(licenciasAux, estadoCliente ? 2 : estadoMostrador ? 1 : 0, e.target.value)


                                        setTextoBuscador(e.target.value)
                                    }} value={textoBuscador} />
                                </div>

                                <div className="grid-item" >
                                    <button id="closeBuscadorClienteTaller" style={{ border: '0', padding: '6px 5px 5px 7px', margin: '0', boxShadown: 'none', visibility: textoBuscador.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2" onClick={(e) => {
                                        setTextoBuscador("");
                                        filtrarDatosLocales(licenciasAux, estadoCliente ? 2 : estadoMostrador ? 1 : 0, "")
                                    }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                                </div>

                                <div className="grid-item barraLateral" ></div>

                                <div className="grid-item">
                                    <button onClick={e => { }} style={{ border: '0', padding: '6px 1px 5px 7px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                                </div>
                            </div>
                        </div>



                        <div style={{ marginTop: '10px' }}>
                            <PrinterOutlined style={{ fontSize: '20px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', cursor: 'pointer' }} onClick={(e) => { setAbrirImpresion(true); buscarDocumento(); }} />
                        </div>

                    </div>


                    {licencias === undefined || licencias === null ?
                        <div style={{ textAlign: 'center' }}>
                            <h4>{traducirPagina("Sin_registros")}</h4>
                        </div>
                        :
                        licencias.length > 0 ?
                            <div style={{ height: (configApp.height - 160).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }}>
                                <table style={{ border: '1px solid #d9d9d9', width: '100%' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#e0e0e0', color: '#000' }}>
                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{"ID"} </th>

                                            <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Taller").toUpperCase()} </th>
                                            <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Pais").toUpperCase()}</th>

                                            <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{"APP"} </th>
                                            <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Telefono").toUpperCase()} </th>
                                            <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{"WEB"} </th>
                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Total").toUpperCase()} </th>
                                            <th style={{ width: '45px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{ } </th>

                                        </tr>
                                    </thead>
                                    <tbody >
                                        {licencias.map((licencia, i) =>

                                            <tr key={i} style={{ backgroundColor: '#fff', color: '#000' }}>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.ID_TALLER}</td>

                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{licencia.TALLER}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{licencia.PAIS}</td>

                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.CONSULTAS_APP}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.CONSULTAS_TELEFONO}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.CONSULTAS_WEB}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.CONSULTAS_TOTAL}</td>

                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                                                    <div className="flex-container-Grow-Simple">
                                                        <div style={{ margin: '0px 2px' }} >
                                                            <button title={"Más ìnformación"} onClick={() => {

                                                                setRegistroSeleccionado(licencia)
                                                                setAbrirFichaEstadistica(true)

                                                            }}
                                                                className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                                <EyeOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                        )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                    }
                </div>
            </Drawer>

            {abrirImpresion ?
                <FichaImpresionGenerico

                    title={traducirPagina("Impresion_doc").toUpperCase()}
                    ABRIR_FICHA={abrirImpresion}
                    CERRAR_FICHA={setAbrirImpresion}

                    DOCUMENTO={DOC_HTML}
                    MODIFICAR_DOCUMENTO={setDOC_HTML}
                    DESCARGAR_DOCUMENTO={buscarDocumentoPDF}
                    DESCARGAR_CSV={buscarDocumentoCSV}
                    VER_CSV={true}

                ></FichaImpresionGenerico>
                :
                null
            }



            {abrirFichaEstadistica ?
                <FichaHistoricoTaller
                    title={`${traducirPagina("Historial_consultas").toUpperCase()}`}
                    ABRIR_FICHA={abrirFichaEstadistica}
                    CERRAR_FICHA={setAbrirFichaEstadistica}

                    MES={props.MES}
                    ANYO={props.ANYO}

                    REGISTRO_SELECCIONADO={registroSeleccionado}

                ></FichaHistoricoTaller>
                :
                null

            }


        </div>

    )

}
FichaHistoricoSocio.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    MES: PropTypes.number,
    ANYO: PropTypes.number,
    ID_SOCIO: PropTypes.number,
    REGISTRO_SELECCIONADO: PropTypes.object,
    ID_DEPARTAMENTO: PropTypes.number,
};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,
        openDrawerEmpresa: state.estadoDrawer.openDrawerEmpresa,

    };
}

export default connect(mapStateToProps)(FichaHistoricoSocio);